import { render, staticRenderFns } from "./Blacklist.vue?vue&type=template&id=37855298&"
import script from "./Blacklist.vue?vue&type=script&lang=js&"
export * from "./Blacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Blacklist.vue?vue&type=custom&index=0&blockType=codepen-resources&lang=json"
if (typeof block0 === 'function') block0(component)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Blacklist.vue
// module id = null
// module chunks = 